import { Component, Input, TemplateRef } from '@angular/core';

// Supposed to be used with bfa-tabs only. Should not be used standalone
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'tab-panel',
	templateUrl: './tab-panel.component.html'
})
export class TabPanelComponent {

	@Input() public templateRef: TemplateRef<any>;
	@Input('active') public isActive?: boolean;
	@Input('tab-title') public title: string;
	@Input() public tooltip?: string;

}
